import {
  CONTACT_NEW_ATTRIBUTE_ORDER_ID,
  CONTACT_HIDE_ATTRIBUTES,
} from "../../../constants";
import { predicateBy, getTemplateData } from "../utils";
import dayjs from "../../../utils/dayjs";
import {
  dateAtTimezone,
  DEFAULT_US_DATE_FORMAT,
} from "../../../utils/dateUtil";

export const getDataGridRows = (
  contactAttributes: Record<string, { value: string }>,
  timeStampTranslatedText: string,
  contactAttributeOrdering?: unknown,
  userTimezone?: string | null,
) => {
  let attributes = [],
    newAttributeId = CONTACT_NEW_ATTRIBUTE_ORDER_ID;

  attributes.push({
    id: 0,
    name: timeStampTranslatedText,
    value: dateAtTimezone(dayjs(), userTimezone ?? "", DEFAULT_US_DATE_FORMAT),
  });

  for (let contactName in contactAttributes) {
    const templateData = getTemplateData(
      contactName,
      contactAttributeOrdering as Record<string, unknown> | null | undefined,
    );
    const isContactNameStartWithVar = contactName
      .toLowerCase()
      .includes("var_");
    if (!isContactNameStartWithVar) {
      const attrValue = contactAttributes[contactName].value;
      templateData
        ? attributes.push({
            id: templateData.id,
            name:
              templateData.name === "ContactID"
                ? "Contact ID"
                : templateData.name,
            value: attrValue,
          })
        : !CONTACT_HIDE_ATTRIBUTES.includes(contactName) &&
          attributes.push({
            id: newAttributeId++,
            name: contactName,
            value: attrValue,
          });
    }
  }

  // Sort by the template/ordering id to produce the intended display order,
  // then reassign sequential ids so MUI DataGrid row keys are always unique.
  // contactAttributeOrdering can legitimately assign the same position number
  // to multiple attributes, which would otherwise cause duplicate DataGrid keys
  // and corrupt rendering (e.g. "Ticket or Case #" appearing twice).
  attributes = attributes.sort(predicateBy("id"));
  return attributes.map((attr, idx) => ({ ...attr, id: idx }));
};
